// @ts-check
export class Admin {
/**
 * 
 * @param {any} main 
 * @param {any} state 
 */
constructor(main,state){
if(!main.isRoot){
    main.utils.notify('Unauthorized',{level:2});
    return;
}
this.m = this.main = main;
this.state = state;
/**@type {any|null}*/this.log$=null;
/**@type {any[]|null}*/this.logs$=null;
}//

/**
 * 
 * @param {HTMLElement} template 
 */
mount(template){
this.m.pbu.replace(this.adminReplace,template);
}//func

async getTemplate(){
    let $this = this;
    this.adminTemplate = this.m.pbu.createElement('main',['admin-component']);
    this.adminTemplate.innerHTML = 
    `
    <header>
   <ul class="nav">
  <li class="nav-item sp-logs">
  </li>

   <li class="nav-item sp-update-database">
  </li>

  <li class="nav-item sp-tests">
  </li>
</ul>
    </header>
    <div id="adminReplace">
      </div>
    `;
    //handle
    this.adminReplace = this.adminTemplate.querySelector('#adminReplace');
    this.logsLink = this.adminTemplate.querySelector('li.sp-logs');
    this.updateDatabaseLink = this.adminTemplate.querySelector('li.sp-update-database');
    this.testsLink = this.adminTemplate.querySelector('li.sp-tests');
    //
    this.m.pbu.getEventButton('Logs',{cb:async()=>{
        this.getLogs().then(r=>this.mount(r));
    },clasz:['nav-link']}).then(r=>this.logsLink.appendChild(r));
    //
    this.m.pbu.getEventButton('Update Database',{cb:async()=>{
        this.updateDatabase().then(r=>this.mount(r));
    },clasz:['nav-link']}).then(r=>this.updateDatabaseLink.appendChild(r));


        //
   this.m.pbu.getEventButton('Tests',{cb:async()=>tests(),clasz:['nav-link']}).then(r=>this.logsLink.appendChild(r));

addEvents();
return this.adminTemplate;
async function tests(){

    let testTemplate = $this.m.pbu.createElement('main');
    testTemplate.innerHTML = 
    `
    <div class="container-fluid vh-100 overflow-hidden">
        <div class="row h-100">
            
            <!-- Column 1: Sidebar -->
            <nav class="col-md-2 d-none d-md-block bg-white border-end p-3 d-flex flex-column">
                <button class="btn btn-primary w-100 mb-4 rounded-pill shadow-sm">
                    <i class="bi bi-pencil-square me-2"></i> Compose
                </button>
                <ul class="nav nav-pills flex-column mb-auto">
                    <li class="nav-item mb-1">
                        <a href="#" class="nav-link active rounded-pill"><i class="bi bi-inbox me-2"></i> Inbox <span class="badge bg-light text-dark float-end">14</span></a>
                    </li>
                    <li class="nav-item mb-1">
                        <a href="#" class="nav-link text-dark rounded-pill"><i class="bi bi-send me-2"></i> Sent</a>
                    </li>
                    <li class="nav-item mb-1">
                        <a href="#" class="nav-link text-dark rounded-pill"><i class="bi bi-file-earmark me-2"></i> Drafts</a>
                    </li>
                    <li class="nav-item mb-1">
                        <a href="#" class="nav-link text-dark rounded-pill"><i class="bi bi-trash me-2"></i> Trash</a>
                    </li>
                </ul>
            </nav>

            <!-- Column 2: Message List -->
            <section class="col-md-4 bg-white border-end p-0 d-flex flex-column h-100">
                <div class="p-3 border-bottom">
                    <input type="search" class="form-control rounded-pill bg-light border-0" placeholder="Search mail...">
                </div>
                <div class="overflow-auto flex-grow-1">
                    <div class="list-group list-group-flush border-bottom">
                        <!-- Message Item -->
                        <a href="#" class="list-group-item list-group-item-action py-3 active">
                            <div class="d-flex w-100 justify-content-between">
                                <h6 class="mb-1 fw-bold">Support Team</h6>
                                <small class="text-muted">12:34 PM</small>
                            </div>
                            <p class="mb-1 fw-semibold text-truncate">Welcome to your new dashboard</p>
                            <small class="text-muted text-truncate d-block">Thanks for joining us. Here is how to get started...</small>
                        </a>
                        <!-- Inactive Message Item -->
                        <a href="#" class="list-group-item list-group-item-action py-3">
                            <div class="d-flex w-100 justify-content-between">
                                <h6 class="mb-1">Jane Doe</h6>
                                <small class="text-muted">Yesterday</small>
                            </div>
                            <p class="mb-1 text-truncate">Project Update Q3</p>
                            <small class="text-muted text-truncate d-block">The reports have been finalized and uploaded...</small>
                        </a>
                    </div>
                </div>
            </section>

            <!-- Column 3: Reading Pane -->
            <main class="col-md-6 p-0 d-flex flex-column h-100 bg-white">
                <div class="p-3 border-bottom d-flex justify-content-between align-items-center bg-white">
                    <div class="btn-group" role="group">
                        <button class="btn btn-outline-secondary btn-sm"><i class="bi bi-archive"></i></button>
                        <button class="btn btn-outline-secondary btn-sm"><i class="bi bi-trash"></i></button>
                        <button class="btn btn-outline-secondary btn-sm"><i class="bi bi-envelope"></i></button>
                    </div>
                    <small class="text-muted">1 of 145</small>
                </div>
                <div class="p-4 overflow-auto flex-grow-1">
                    <h4 class="mb-3">Welcome to your new dashboard</h4>
                    <div class="d-flex align-items-center mb-4">
                        <div class="bg-secondary text-white rounded-circle d-flex align-items-center justify-content-center me-3" style="width: 40px; height: 40px;">ST</div>
                        <div>
                            <h6 class="mb-0 fw-bold">Support Team <small class="text-muted fw-normal">&lt;support@example.com&gt;</small></h6>
                            <small class="text-muted">To: you@example.com</small>
                        </div>
                    </div>
                    <div class="email-body">
                        <p>Thanks for joining us. Here is how to get started with your new account dashboard.</p>
                        <p>Best regards,<br>The Team</p>
                    </div>
                </div>
            </main>

        </div>
    </div>
    `;
    $this.mount(testTemplate);
    }//inner
    async function addEvents(){
    }//inner
}//


async getLogs(){
let $this = this;
this.logListTemplate = this.m.pbu.createElement('div');
this.logListTemplate.innerHTML = 
`
<div class="container-fluid py-4">
    <!-- Header -->
    <div class="sp-log-entries d-flex justify-content-between align-items-center mb-3">
        <h4 class="mb-0">Log Entries</h4><div class="sp-refresh"></div>
    </div>

    <!-- Filters -->
    <div class="card mb-3">
        <div class="card-body py-2">
            <div class="row g-2 align-items-end">
                ${this.main.pbu.createSelectElement({title:"Level",value:'All',clasz:['form-select-sm'],labelClasz:['small','mb-1'],divClasz:['col-md-2'],items:['All','0','1','2'],serialize:true})}
                ${this.main.pbu.createSelectElement({title:"Log Type",value:'All',clasz:['form-select-sm'],labelClasz:['small','mb-1'],divClasz:['col-md-2'],items:['All','INFO','EXCEPTION','AUDIT'],serialize:true})}
                ${this.main.pbu.createFormControl({title:'Tenant',clasz:['tenant-username','form-control-sm'],labelClasz:['small','mb-1'],divClasz:['col-md-2'],placeholder:'username',serialize:true})}
                ${this.main.pbu.createFormControl({type:'datetime-local',title:'Fromll',clasz:['form-control-sm'],labelClasz:['small','mb-1'],divClasz:['col-md-2'],placeholder:'username',serialize:true})}
                ${this.main.pbu.createFormControl({type:'datetime-local',title:'To',clasz:['form-control-sm'],labelClasz:['small','mb-1'],divClasz:['col-md-2'],placeholder:'username',serialize:true})}
                <div class="col-md-2">
                    <button class="btn btn-sm btn-primary w-100">Apply Filters</button>
                </div>
            </div>
        </div>
    </div>

    <!-- Log Table -->
    <div class="card">
        <div class="table-responsive">
            <table class="table table-striped mb-0">
                <thead class="table-light">
                    <tr>
                        <th style="width: 170px;">Timestamp</th>
                        <th style="width: 110px;">Tenant</th>
                        <th style="width: 110px;">User</th>
                        <th style="width: 90px;">Level</th>
                        <th style="width: 140px;">Log Type</th>
                        <th style="width: 90px;">Source</th>
                        <th style="width: 90px;">Action</th>
                        <th>Message</th>
                        <th style="width: 60px;">Details</th>
                    </tr>
                </thead>
                <tbody>
                </tbody>
            </table>
        </div>

        <!-- Pagination -->
        <div class="card-footer d-flex justify-content-between align-items-center">
            <small class="text-muted">Showing 4 of 1,204 entries</small>
            <nav>
                <ul class="pagination pagination-sm mb-0">
                    <li class="page-item disabled"><a class="page-link" href="#">Previous</a></li>
                    <li class="page-item active"><a class="page-link" href="#">1</a></li>
                    <li class="page-item"><a class="page-link" href="#">2</a></li>
                    <li class="page-item"><a class="page-link" href="#">3</a></li>
                    <li class="page-item"><a class="page-link" href="#">Next</a></li>
                </ul>
            </nav>
        </div>
    </div>

</div>
`;
//handle
let tb = this.logListTemplate.querySelector('tbody');
this.m.pbu.getEventButton('Refresh',{cb:()=>{
getLogs(this.logListTemplate.querySelector('input.tenant-username').value);
},icon:'arrow-clockwise'}).then(r=>this.m.pbu.replace(this.logListTemplate.querySelector('div.sp-refresh'),r));

await getLogs();
return this.logListTemplate;  

/**
 * 
 * @param {any}log -the log 
 */
async function getDetailTemplate(log){
$this.logDetailTemplate = $this.m.pbu.createElement('div');
$this.logDetailTemplate.innerHTML = 
`
<div class="container-fluid py-4">

    <!-- Breadcrumb + actions -->
    <div class="d-flex justify-content-between align-items-center mb-3">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb mb-0">
                <li class="breadcrumb-item">Logs</li>
                <li class="breadcrumb-item">${log.username}</li>
            </ol>
        </nav>
        <div class="d-flex gap-2">
        <button class="btn btn-sm btn-outline-secondary">Copy JSON</button>
            <button class="btn btn-sm btn-outline-secondary">Prev</button>
            <button class="btn btn-sm btn-outline-secondary">Next</button>
        </div>
    </div>

    <!-- Header card: level + message -->
    <div class="card mb-3 border-start border-4 border-${$this.m.utils.getContextualClass(log.level)}">
        <div class="card-body">
            <div class="d-flex align-items-center gap-2 mb-2">
                <span class="badge bg-${$this.m.utils.getContextualClass(log.level)}">${log.logType}</span>
                <code class="text-muted small">${log.action}</code>
                <span class="text-muted small ms-auto log-mono">${log.creationDate}</span>
            </div>
            <h5 class="mb-0 log-message">
                ${log.message}
            </h5>
        </div>
    </div>

    <div class="row g-3">

        <!-- LEFT: Metadata sidebar -->
        <div class="col-lg-4">

            <!-- Identity -->
            <div class="card mb-3">
                <div class="card-header bg-white fw-semibold small">Identity</div>
                <div class="card-body py-2">
                    <div class="row g-2">
                        <div class="col-6">
                            <div class="meta-label">Tenant</div>
                            <div class="meta-value">
                               ${log.username}
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="meta-label">User</div>
                            <div class="meta-value log-mono">User</div>
                        </div>
                        
                    </div>
                </div>
            </div>

            <!-- Timing -->
            <div class="card mb-3">
                <div class="card-header bg-white fw-semibold small">Time</div>
                <div class="card-body py-2">
                    <div class="row g-2">
                        <div class="col-12">
                            <div class="meta-label">Timestamp</div>
                            <div class="meta-value log-mono">${log.creationDate}</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Exception summary -->
            <div class="card mb-3 border-danger ${$this.m.pbu.showIf(log.exceptionType && log.exceptionMessage)}">
                <div class="card-header bg-danger text-white fw-semibold small">
                    Exception
                </div>
                <div class="card-body py-2">
                    <div class="meta-label">Type</div>
                    <div class="meta-value log-mono text-danger">
                        ${log.exceptionType}
                    </div>
                    <div class="meta-label mt-2">Message</div>
                    <div class="meta-value log-mono">${log.exceptionMessage}</div>
                    <div class="meta-label mt-2">Root Cause</div>
                    <div class="meta-value log-mono text-danger">
                      ${log.exceptionRootCause}  
                    </div>
                    <div class="meta-label mt-2">Suppressed</div>
                    <div class="meta-value log-mono text-warning">
                        ...
                    </div>
                </div>
            </div>

        </div>

        <!-- RIGHT: Main content -->
        <div class="col-lg-8">

            <!-- Tabs -->
            <ul class="nav nav-tabs" id="detailTabs" role="tablist">
                <li class="nav-item" role="presentation">
                    <button class="nav-link active" data-bs-toggle="tab"
                            data-bs-target="#tab-stack" type="button">Stack Trace</button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link" data-bs-toggle="tab"
                            data-bs-target="#tab-context" type="button">Application State</button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link" data-bs-toggle="tab"
                            data-bs-target="#tab-raw" type="button">Raw JSON</button>
                </li>
            </ul>

            <div class="tab-content bg-white border border-top-0 rounded-bottom p-3">

                <!-- Stack trace -->
                <div class="tab-pane fade show active" id="tab-stack">
                    <pre class="log-stack log-pre">${log.exceptionStackTrace}</pre>
                </div>

                <!-- Context (MDC + custom fields) -->
                <div class="tab-pane fade" id="tab-context">
                    <h6 class="small text-uppercase text-muted mb-2">SP Context</h6>
                    <table class="table table-sm log-mono mb-4">
                        <tbody>
                            <tr><td class="kv-key">Tenant username</td> <td>${log.username}</td></tr>
                            <tr><td class="kv-key">Tenant id</td> <td>${log.tenantId}</td></tr>
                            <tr><td class="kv-key">Tenant uuid</td> <td>${log.tenantUuid}</td></tr>
                        </tbody>
                    </table>

                    <h6 class="small text-uppercase text-muted mb-2">Context</h6>
                    <table class="table table-sm log-mono mb-4">
                        <tbody>
                            <tr><td class="kv-key">component</td><td class="kv-number">${log.state?.component}</td></tr>
                            <tr><td class="kv-key">postType</td><td class="kv-number">${log.state?.postType}</td></tr>
                            <tr><td class="kv-key">archiveType</td><td class="kv-string">${log.state?.archiveType}</td></tr>
                            <tr><td class="kv-key">title</td><td class="kv-number">${log.state?.title}</td></tr>
                            <tr><td class="kv-key">id</td><td class="kv-number">${log.state?.id}</td></tr>
                            <tr><td class="kv-key">request method</td><td class="kv-string">${log.state?.method}</td></tr>
                            <tr><td class="kv-key">isInit</td><td class="kv-number">${log.state?.isInit}</td></tr>
                            <tr><td class="kv-key">isHome</td><td class="kv-number">${log.state?.isHome}</td></tr>
                            <tr><td class="kv-key">nextStateUrl</td><td class="kv-number">${log.state?.nextStateUrl}</td></tr>
                        </tbody>
                    </table>
                </div>

                <!-- Raw JSON -->
                <div class="tab-pane fade" id="tab-raw">
        <pre class="log-pre log-mono" style="background:#f8f9fa; padding:1rem; border-radius:.375rem; max-height:420px; overflow:auto;">${JSON.stringify(log)}</pre>
                </div>

            </div>
        </div>
    </div>

</div>

`;

return $this.logDetailTemplate;
}//

/**
 * 
 * @param {string} username 
 */
async function getLogs(username='all') {
let r = await $this.main.fu.fetch({link:$this.main.fu.getApi(`/app/log/find/${username}`)});
if(r){
    tb.innerHTML = '';
    for(let logString of r){
        $this.m.log(logString,":  logString");
        let log = JSON.parse(logString);
        $this.m.log(log,"getting log Log");
        let tr = $this.m.pbu.createElement('tr');
        tb.appendChild(tr);
        tr.innerHTML = 
        `
        <td>${log.creationDate}</td>
        <td>${log.username}</td>
        <td>user</td>
        <td><span class="badge text-bg-${$this.m.utils.getContextualClass(log.level)}">${log.level}<span/></td>
        <td>${log.logType}</td>
        <td>${log.source}</td>
        <td>${log.action}</td>
        <td>${log.message}</td>
        <td class="sp-log-detail">
        </td>
        `;
        $this.m.pbu.getEventButton('Details',{cb:async()=>{
            $this.m.modal = $this.m.utils.setModal("Log Detail",await getDetailTemplate(log),false,{clasz:['modal-xl']});
        }}).then(r=>$this.m.pbu.replace(tr.querySelector('td.sp-log-detail'),r));
    }
}   
}//inner
}//


/**
 * 
 * @param {boolean} init 
 */
async updateDatabase(init=true){
let $this = this;
let tenant,SQL;
if(init){
    return getTemplate();
}else {
    update();
}

async function getTemplate() {
let form = $this.m.pbu.createElement('form');
    form.innerHTML = 
    `
    <textarea rows="10" class="sp-textarea form-control"></textarea>
    `;
    $this.m.pbu.getEventButton('Update',{cb:()=>{
        let SQL = form.querySelector('textarea').value;
        update(SQL);
    }}).then(b=>{
        $this.m.pbu.appendChildIf(form,b);
    });    
    return form;
}//inner

/**
 * 
 * @param {string} SQL 
 * @param {string} tenant 
 */
async function update(SQL,tenant= 'all'){
//"api/{username}/app/update-database/{tenantSchema}
let r = await $this.main.fu.fetch({
    link:$this.main.fu.getApi(`/app/update-database/${tenant}`),
    body:SQL
});
if(r=='ok'){
$this.main.utils.notify('Updated',{level:0});
}
}//inner
}//func

async save(){
this.m.utils.finilizeSave(this);
}//func

//######

getItems(){
    return this.logs$;
}
/**
 * 
 * @param {any} items 
 */
async setItems(items){
this.state.stateObject.logs = items;
await this.setDisplay();
}
}//class

function getDetailTemplate(arg0) {
    throw new Error("Function not implemented.");
}

